'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SortableListHeader.scss');

var cn = _bind2.default.bind(styles);

var SortableListHeader = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(SortableListHeader, _PureComponent);

  function SortableListHeader() {
    (0, _classCallCheck3.default)(this, SortableListHeader);
    return (0, _possibleConstructorReturn3.default)(this, (SortableListHeader.__proto__ || (0, _getPrototypeOf2.default)(SortableListHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableListHeader, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          name = _props.name,
          onReorder = _props.onReorder;

      onReorder(name);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          order = _props2.order,
          activeOrder = _props2.activeOrder,
          name = _props2.name,
          title = _props2.title,
          className = _props2.className;

      var orderClass = (0, _bind2.default)(styles['order-' + order[name]], styles.order);
      var sorterClass = cn('sorter', className, { active: activeOrder === name });

      return _react2.default.createElement(
        'div',
        { className: sorterClass, onClick: this.onClick },
        title,
        _react2.default.createElement('i', { className: orderClass })
      );
    }
  }]);
  return SortableListHeader;
}(_react.PureComponent), _class2.propTypes = {
  activeOrder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onReorder: _propTypes2.default.func,
  order: _propTypes2.default.object,
  title: _propTypes2.default.string
}, _class2.defaultProps = {
  onReorder: _noop3.default,
  order: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = SortableListHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SortableListHeader/SortableListHeader.js
// module id = 355
// module chunks = 1